import React, { Children, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media } from '@clds/style-utils';

export interface CookbookTransformationCardLayoutProps {
  isHovered: boolean;
  leftContent: React.ReactElement;
  rightContent?: React.ReactElement;
}

const Root = styled.section<{ isHovered: boolean }>`
  display: flex;
  flex-direction: row;
  padding: ${globalTheme.spacing.lg};
  border-radius: ${globalTheme.radius.lg};
  background-color: ${globalTheme.palette.surface};
  min-width: calc(200px + 2 * ${globalTheme.spacing.lg});
  transition: box-shadow 0.2s ease-out;

  ${(props) =>
    props.isHovered &&
    css`
      box-shadow: ${globalTheme.shadow.sm};
    `};
`;

const LeftPane = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  @media ${media.phone({ maxOnly: true })} {
    flex-grow: 1;
  }
`;

const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: ${globalTheme.spacing.lg};
  min-width: 0;
`;

export const CookbookCardLayout = forwardRef<HTMLElement, CookbookTransformationCardLayoutProps>(({ isHovered, leftContent, rightContent }, ref) => (
  <Root isHovered={isHovered} ref={ref} data-test="cookbook-card-layout">
    {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
    {Children.count(leftContent?.props?.children) > 0 && <LeftPane>{leftContent}</LeftPane>}
    {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
    {Children.count(rightContent?.props?.children) > 0 && <RightPane>{rightContent}</RightPane>}
  </Root>
));
